// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd1375c5","239":"f49bf831","453":"54125997","553":"31f97ac4"}[chunkId] + ".chunk.js";
};